import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import { http, blockGetData, common } from './export.js'
import router from './router'
import store from './store/index'

import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/reset.css'
import './assets/css/contextmuse.css'
import './assets/css/right.scss'
import { CascaderPanel, Tree, Slider, Table, TableColumn, Notification, Image, Rate, Pagination, Button, Loading, Message, Switch } from 'element-ui'

Vue.prototype.$blockGetData = blockGetData

Vue.prototype.$common = common
Vue.component(CascaderPanel.name, CascaderPanel)
Vue.use(Loading.directive)
Vue.component(Switch.name, Switch)
Vue.component(Tree.name, Tree)
Vue.component(Slider.name, Slider)
Vue.component(Table.name, Table)
Vue.component(TableColumn.name, TableColumn)
Vue.component(Image.name, Image)
Vue.component(Rate.name, Rate)
Vue.component(Pagination.name, Pagination)
Vue.component(Button.name, Button)
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
Vue.prototype.$backArr = []
import base from './base' //引用
Vue.use(base) //将全局函数当做插件来进行注册

Vue.prototype.$appId = location.pathname.indexOf('shopCart') > -1 ? Vue.prototype.getQuery('shopId') : Vue.prototype.getQuery('appId') ? Vue.prototype.getQuery('appId') : location.hostname.split('.')[0].indexOf('www') > -1 ? location.hostname.split('.')[1] : location.hostname.split('.')[0]
Vue.prototype.$contentId = Vue.prototype.getQuery('contentId') ? Vue.prototype.getQuery('contentId') : Vue.prototype.getQuery('communicationId') ? Vue.prototype.getQuery('communicationId') : ''

// Vue.prototype.$http = axios;
Vue.prototype.$http = http
Window.$http = http

Vue.config.productionTip = false

window.newVue = new Vue({
  store,
  router,
  render: (h) => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js